import React, { useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import { Button, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import { formatDateTimeLocalDate } from '../../../utilities/Utils'
import { FaEye, FaPaperPlane, FaPrint } from 'react-icons/fa'
import ModalProsesNonLalin from '../modal/ModalProsesNonLalin'
import ModalSppNonLalin from '../modal/ModalSppNonLalin'
import ModalCetakNonLalin from '../modal/ModalCetakNonLalin'
import ModalBast from '../modal/ModalBast'
import ModalLhpNonLalin from '../modal/ModalLhpNonLalin'
import ModalPnbpNonLalinV2 from '../modal/ModalPnbpNonLalinV2'
import ModalSppScanning from '../modal/ModalSppScanning'
import ModalSppSample from '../modal/ModalSppSample'
import ModalLhpScanning from '../modal/ModalLhpScanning'
import ModalLhpSample from '../modal/ModalLhpSample'

const ExpandableComponentNonLalin = ({ data, reloadList }) => {
    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const _resDispo = await nonLalinService.listNonlalinPenugasanAll(data.nomorAju)
                setListDisposisi(_resDispo.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [nonLalinService, data])


    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listDisposisi.map((disp, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><NonlalinDisposisi idDisposisi={disp.idDisposisi} /></h6>
                                            <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.createdAt)}</small>
                                            <div className="d-inline-block w-100">
                                                <DisposisiProses datappm={data} dataPenugasan={disp} reloadList={reloadList} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const DisposisiProses = ({ datappm, dataPenugasan, reloadList }) => {
    // console.log(dataPenugasan)
    const [dataDisposisi, setDataDisposisi] = useState({})

    const [showCetak, setShowCetak] = useState(false)
    const handleCloseCetak = () => setShowCetak(false)

    const [showAddProses, setShowAddProses] = useState(false)
    const handleCloseAddProses = () => setShowAddProses(false)
    const [showAddPenugasan, setShowAddPenugasan] = useState(false);
    const handleCloseAddPenugasan = () => setShowAddPenugasan(false);
    const [showAddBast, setShowAddBast] = useState(false);
    const handleCloseAddBast = () => setShowAddBast(false);
    const [showAddLhp, setShowAddLhp] = useState(false);
    const handleCloseAddLhp = () => setShowAddLhp(false);
    const [showAddPnbp, setShowAddPnbp] = useState(false)
    const handleCloseAddPnbp = () => setShowAddPnbp(false)

    //scanning
    const [showAddSppScanning, setShowAddSppScanning] = useState(false)
    const handleCloseAddSppScanning = () => setShowAddSppScanning(false)
    const [showAddSppSample, setShowAddSppSample] = useState(false)
    const handleCloseAddSppSample = () => setShowAddSppSample(false)
    const [showAddLhpScan, setShowAddLhpScan] = useState(false)
    const handleCloseAddLhpScan = () => setShowAddLhpScan(false)
    const [showAddLhpSample, setShowAddLhpSample] = useState(false)
    const handleCloseAddLhpSample = () => setShowAddLhpSample(false)

    const [isEdit, setIsEdit] = useState(false)

    const handleShowAdd = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            localStorage.setItem('isEditStorage', '1')
            setIsEdit(true)
            setShowAddProses(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            setIsEdit(true)
            setShowAddPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setIsEdit(true)
            setShowAddBast(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            setIsEdit(true)
            setShowAddLhp(true)
        } else if (dataPenugasan.idDisposisi === 5) {
            setIsEdit(true)
            setShowAddPnbp(true)
        } else if (dataPenugasan.idDisposisi === 16){
            setIsEdit(true)
            setShowAddSppScanning(true)
        } else if (dataPenugasan.idDisposisi === 17){
            setIsEdit(true)
            setShowAddSppSample(true)
        } else if (dataPenugasan.idDisposisi === 18){
            setIsEdit(true)
            setShowAddLhpScan(true)
        } else if (dataPenugasan.idDisposisi === 20){
            setIsEdit(true)
            setShowAddLhpSample(true)
        }
    }

    const handleShowView = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            localStorage.setItem('isEditStorage', '0')
            setIsEdit(false)
            setShowAddProses(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            setIsEdit(false)
            setShowAddPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setIsEdit(false)
            setShowAddBast(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            setIsEdit(false)
            setShowAddLhp(true)
        } else if (dataPenugasan.idDisposisi === 5){
            setIsEdit(false)
            setShowAddPnbp(true)
        } else if (dataPenugasan.idDisposisi === 16){
            setIsEdit(false)
            setShowAddSppScanning(true)
        } else if (dataPenugasan.idDisposisi === 17){
            setIsEdit(false)
            setShowAddSppSample(true)
        } else if (dataPenugasan.idDisposisi === 18){
            setIsEdit(false)
            setShowAddLhpScan(true)
        } else if (dataPenugasan.idDisposisi === 20){
            setIsEdit(false)
            setShowAddLhpSample(true)
        }
    }

    const handleClickCetak = (dataPenugasan) => {
        // console.log('cetak')
        setDataDisposisi(dataPenugasan)
        setShowCetak(true)
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-4">
                    {
                        ((localStorage.getItem("role") !== '4' && localStorage.getItem("role") !== '5' && localStorage.getItem("role") !== '8') && dataPenugasan.noTugas === null) &&
                        // (dataPenugasan.noTugas === null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleShowAdd(dataPenugasan)}>
                                    <FaPaperPlane /> Proses
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        (dataPenugasan.noTugas !== null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShowView(dataPenugasan)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {(dataPenugasan.idDisposisi !== 1 && 
                    dataPenugasan.idDisposisi !== 16 && dataPenugasan.idDisposisi !== 17 && 
                    dataPenugasan.idDisposisi !== 18 && dataPenugasan.idDisposisi !== 20 && dataPenugasan.noTugas !== null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak</Tooltip>
                            }>
                                <Button size="sm" variant="outline-warning" onClick={() => handleClickCetak(dataPenugasan)}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                </div>
            </div>
            <ModalProsesNonLalin showAddProses={showAddProses} handleCloseAddProses={handleCloseAddProses} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit} />
            <ModalSppNonLalin showAddPenugasan={showAddPenugasan} handleCloseAddPenugasan={handleCloseAddPenugasan} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
            <ModalBast showAddBast={showAddBast} handleCloseAddBast={handleCloseAddBast} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
            <ModalLhpNonLalin showAddLhp={showAddLhp} handleCloseAddLhp={handleCloseAddLhp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
            <ModalPnbpNonLalinV2 showAddPnbp={showAddPnbp} handleCloseAddPnbp={handleCloseAddPnbp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
            <ModalCetakNonLalin showCetak={showCetak} handleCloseCetak={handleCloseCetak} dataDisposisi={dataDisposisi} datappm={datappm} />
            {/* Scanning */}
            <ModalSppScanning showAddSppScanning={showAddSppScanning} handleCloseAddSppScanning={handleCloseAddSppScanning} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit} />
            <ModalSppSample showAddSppSample={showAddSppSample} handleCloseAddSppSample={handleCloseAddSppSample} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit} />
            <ModalLhpScanning showAddLhpScan={showAddLhpScan} handleCloseAddLhpScan={handleCloseAddLhpScan} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
            <ModalLhpSample showAddLhpSample={showAddLhpSample} handleCloseAddLhpSample={handleCloseAddLhpSample} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
        </>
    )
}

export default ExpandableComponentNonLalin